<template>
  <div>
    <div class="boxs">
      <div class="top">{{ item.eventTitle }}</div>
      <div class="content">
        <Row>
          <Col :span="24"><span class="title">发生区域:</span>{{ item.incidentArea }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span
            class="title">发生时间:</span>{{ $moment(item.eventReceptionTime).format('yyyy-MM-DD hh:mm:ss') }}
          </Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">事件描述:</span>{{ item.eventDescription }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">事件状态:</span>{{ item.status }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">上报人:</span>{{ item.reportPerson }}</Col>
        </Row>
        <Row>
          <Col :span="24"><span class="title">上报电话:</span>{{ item.reportPhone }}</Col>
        </Row>
        <!--        <Row>-->
        <!--          <Col :span="24"><span class="title">所在位置:</span>{{ item.unitName }}</Col>-->
        <!--        </Row>-->
      </div>
      <div class="footer">
        <div class="btns" @click="eventModalIsShow">进入事件</div>
      </div>
    </div>
    <Modal v-model="eventModal"
           footer-hide
           width="80">
      <emergencyResponse :event-info="item"></emergencyResponse>
    </Modal>
  </div>
</template>

<script>
import emergencyResponse from '../../../../emergencyResponse/emergencyResponse.vue'

export default {
  name: "EventWidnows",
  components: {
    emergencyResponse
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      eventModal: false
    }
  },
  methods: {
    eventModalIsShow() {
      this.eventModal = true
    },
  }
}
</script>

<style scoped lang="less">
//@import "./css/modal.less";

.boxs {
  position: relative;
  height: 12rem;
  .top {
    color: #ffffff;
    height: 4vh;
    line-height: 4vh;
    padding-left: .5rem;
    font-size: .7rem;
  }

  .content {
    padding-left: .5rem;
    color: #ffffff;
    font-size: .7rem;
    overflow: auto;
    height: 70%;

    .title, .ivu-col {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90%;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    .ivu-col {
      line-height: 1.4rem;
    }

    .title {
      color: #72aefa;
    }
  }

  .footer {
    height: 20%;
    width: 100%;
    position: absolute;
    bottom: -5px;
    left: 0;
    z-index: 999999;

    .btns {
      width: 20%;
      height: 2vh;
      margin: 1vh auto;
      cursor: pointer;
      background-image: url("../../../images/exitBtnBg.png");
      background-size: 100% 100%;
      color: #ffffff;
      line-height: 2.2vh;
      text-align: center;
      font-size: .2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      &:hover {
        color: #BCCBEF;
      }
    }
  }
}
</style>
